export { default as evaluateSafeLink, evaluateSafeLinks } from './utils/evaluateSafeLink';
export { isSafeLink } from './utils/isSafeLink';
